import script from "./BillingUpdateYearLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingUpdateYearLevel.vue?vue&type=script&setup=true&lang=js"

import "./BillingUpdateYearLevel.vue?vue&type=style&index=0&id=84322ab2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84322ab2"]])

export default __exports__